// extracted by mini-css-extract-plugin
export default {"container":"XviMm_LDGiaQtJCWEfTo"};